import {
  CreateResourceIdempotencyToken,
  FeatureRegistry,
  FlowSubmissionIdempotencyToken,
  ResendActionIdempotencyToken,
  SendEmailIdempotencyToken,
  ToggleIdempotencyToken,
  UpdateResourceIdempotencyToken,
  ValidationIdempotencyToken,
} from '@betterment/graphql';

export const featureRegistry: FeatureRegistry = {
  addEnvelopeExternalAccounts: {
    AddEnvelopeExternalAccounts: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  cancelTransactionRequest: {
    CancelTransactionRequest: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  createAccountRecommendation: {
    CreateAccountRecommendation: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  createDirectTradingAccount: {
    CreateDirectTradingAccount: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  createEmployeeContributionConfigChange: {
    CreateEmployeeContributionConfigChange: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  documentVerification: {
    CreateDocumentVerificationToken: { idempotencyToken: CreateResourceIdempotencyToken },
    SubmitDocumentVerification: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  deletePurpose: {
    DeletePurpose: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  depositSetup: {
    SendWireTransferInstructionsEmailV2: { idempotencyToken: ResendActionIdempotencyToken },
  },
  editBeneficiaries: {
    UpdateLegalAccountBeneficiaries: { idempotencyToken: FlowSubmissionIdempotencyToken },
    ValidateLegalAccountBeneficiary: { idempotencyToken: ValidationIdempotencyToken },
  },
  editCheckingBeneficiary: {
    UpdateCheckingBeneficiary: { idempotencyToken: FlowSubmissionIdempotencyToken },
    DeleteCheckingBeneficiary: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  editUserLevelSettings: {
    EditUserLevelSettings: { idempotencyToken: ToggleIdempotencyToken },
  },
  emailVerificationCheckpoint: {
    SendEmailVerificationEmail: { idempotencyToken: SendEmailIdempotencyToken },
  },
  employmentFourOhOneKStudentLoanBenefitEndOfYearAttestationFlow: {
    UpdateStudentLoanPaymentBenefitAttestation: { idempotencyToken: FlowSubmissionIdempotencyToken },
    InitiateStudentLoanPaymentBenefitAttestation: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  envelopes: {
    UpdateEnvelopeOrders: { idempotencyToken: UpdateResourceIdempotencyToken },
  },
  financialSecurityBuyOrderRequest: {
    CreateFinancialSecurityOrderRequest: { idempotencyToken: FlowSubmissionIdempotencyToken },
    ValidateFinancialSecurityOrderRequest: { idempotencyToken: ValidationIdempotencyToken },
  },
  financialSecuritySellOrderRequest: {
    CreateFinancialSecurityOrderRequest: { idempotencyToken: FlowSubmissionIdempotencyToken },
    ValidateFinancialSecurityOrderRequest: { idempotencyToken: ValidationIdempotencyToken },
  },
  investingJournal: {
    CreateTransactionMemo: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  settings: {
    UpdateUserPostalAddresses: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  advisorNetwork: {
    UpdateAdvisorNetworkIntent: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  updateFinancialProfileRetirementAssumptions: {
    UpdateFinancialProfileRetirementAssumptions: { idempotencyToken: FlowSubmissionIdempotencyToken },
  },
  clientEnvelopeApprovals: {
    AcceptAdvisoryRelationshipApprovalRequest: { idempotencyToken: CreateResourceIdempotencyToken },
  },
  solo401kInterestFlow: {
    CreateSolo401kInterestSubmissions: { idempotencyToken: CreateResourceIdempotencyToken },
  },
};
